import classNames from 'classnames';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuickLinkButtons } from '../../../screens/dashboard/QuickOperateButton';

const DASHBOARD_LINK = '/dashboard';

const isQuickLinkDisabled = (item) => !item?.link || item.link === '#!' || String(item.link).startsWith('#');

const isQuickLinkActive = (pathname, link) => {
	if (!link || !pathname) return false;
	return pathname === link || pathname.startsWith(`${link}/`);
};

const displayTitle = (title) => String(title || '').replace(/-Admin$/, '');

/**
 * 对齐 Falcon `NavbarTopDropDownMenus`：无 icon 文字顶栏。
 * 回首页由顶栏 Logo 承担，此处不重复「首页」项。
 */
const NavbarTopWorkMenus = () => {
	const { pathname } = useLocation();
	const quickLinks = useQuickLinkButtons();

	const items = useMemo(
		() => (quickLinks || []).filter((item) => !isQuickLinkDisabled(item) && item.link !== DASHBOARD_LINK),
		[quickLinks],
	);

	return (
		<>
			{items.map((item) => {
				const active = isQuickLinkActive(pathname, item.link);
				return (
					<Nav.Link key={item.link} as={Link} to={item.link} className={classNames('fw-semibold', { active })}>
						{displayTitle(item.title)}
					</Nav.Link>
				);
			})}
		</>
	);
};

export default NavbarTopWorkMenus;
